jQuery(function ($) {
  // $(window).scroll(function () {
  //   if ($(window).scrollTop() >= 110) {
  //     $(".header__inline-menu").addClass("fixed-header");
  //   } else {
  //     $(".header__inline-menu").removeClass("fixed-header");
  //   }
  // });
  // $(window).scroll(function () {
  //   if ($(window).scrollTop() >= 100) {
  //     $(".navDiv").addClass("fixed-header");
  //   } else {
  //     $(".navDiv").removeClass("fixed-header");
  //   }
  // });
    // 

  // Home Banner Slider
  $("#homeslider").owlCarousel({
    loop: true,
    margin: 0,
    dots: true,
    nav: false,
    autoplay: true,
    autoplayTimeout: 4000,
    autoplayHoverPause: true,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
      },
      420: {
        items: 1,
      },
      600: {
        items: 1,
      },
    },
  });

  $(".collectionslider").slick({
    slidesToShow: 5,
    slidesToScroll: 4,
    dots: true,
    arrows: false,
    infinite: true,
    adaptiveHeight: false,
    draggable: true,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 1366,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 3,
        },
      },
    ],
  });

  // Collection Slider
  // $(".collectionslider").owlCarousel({
  //   loop: true,
  //   margin: 0,
  //   dots: true,
  //   nav: false,
  //   autoplay: false,
  //   slideBy: 1,
  //   freedrag: true,
  //   mouseDrag: true,
  //   touchDrag: true,
  //   pullDrag: true,
  //   responsiveClass: true,
  //   responsive: {
  //     0: {
  //       items: 1,
  //     },
  //     480: {
  //       items: 2,
  //     },
  //     768: {
  //       items: 3,
  //     },
  //     1024: {
  //       items: 4,
  //     },
  //     1366: {
  //       items: 5,
  //     },
  //   },
  // });

  // Blog Slider
  $("#blogslider").owlCarousel({
    loop: true,
    margin: 0,
    dots: true,
    nav: false,
    autoplay: false,
    slideBy: 1,
    autoplayTimeout: 4000,
    autoplayHoverPause: true,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
      },
      576: {
        items: 2,
      },
      992: {
        items: 3,
      },
    },
  });

  // product-details-expand
  // $(".expandTitle:first").addClass('open').next(".details").slideDown();
  $(".expandTitle").click(function () {
    $(".details").slideUp();
    $(".expandTitle").removeClass("open");
    if ($(this).next(".details").is(":hidden")) {
      $(this).next(".details").slideDown();
      $(this).addClass("open");
    }
  });

  // faq
  // $(".faqTitle:first").addClass('open').next(".faqDetails").slideDown();
  $(".faqTitle").click(function () {
    $(".faqDetails").slideUp();
    $(".faqTitle").removeClass("open");
    if ($(this).next(".faqDetails").is(":hidden")) {
      $(this).next(".faqDetails").slideDown();
      $(this).addClass("open");
    }
  });
});
